<script lang="ts">
  import {t} from '../i18n'
  import {modal} from '../stores/modal'
  import api from '../api/api'
  import ModalTemplate from '../shared/ModalTemplate.svelte'
  import ValidationMessage from '../shared/ValidationMessage.svelte'

  let recovery = {email: '', captcha: ''}
  let errors: string[] | null = null

  async function submit(e: Event) {
    e.preventDefault()
    await api.post('/authentication/send_recovery', {recovery}).catch(response => {
      errors = response.errors
    })

    modal.close()
  }
</script>

<ModalTemplate size="tiny">
  <div class="modal-content">
    <form onsubmit={submit}>
      <h2 class="reg-log-title">
        <span>{t.password_recovery.title}</span>
      </h2>

      <div class="line">
        <input required type="email" placeholder={t.password_recovery.email} bind:value={recovery.email}/>
        <ValidationMessage {errors}/>
      </div>

      <button type="submit" class="ui button black">{t.password_recovery.send}</button>
    </form>
  </div>
</ModalTemplate>